// NGRX
import { Store, select } from '@ngrx/store';
// CRUD
import { BaseDataSource, QueryResultsModel } from '../../_base/crud';
// State
import { AppState } from '../../../core/reducers';
// Selectors
import {
  selectQueryResult,
  selectAgreementsPageLoading,
  selectAgreementsShowInitWaitingMessage,
} from '../_selectors/agreement.selectors';

export class AgreementsDataSource extends BaseDataSource {
  constructor(private store: Store<AppState>) {
    super();

    this.loading$ = this.store.pipe(select(selectAgreementsPageLoading));

    this.isPreloadTextViewed$ = this.store.pipe(select(selectAgreementsShowInitWaitingMessage));

    this.store.pipe(select(selectQueryResult)).subscribe((response: QueryResultsModel) => {
      this.paginatorTotalSubject.next(response.totalCount);
      this.entitySubject.next(response.items);
    });
  }
}
